// Neither IE nor Safari (desktop) support Intl.NumberFormat properly, so polyfill anyway
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-getcanonicallocales/polyfill'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'
import '@formatjs/intl-numberformat/polyfill'
import '@formatjs/intl-numberformat/locale-data/en'

const symbolFormattingOnly = {
  style: 'currency',
  currencyDisplay: 'narrowSymbol'
}

export const Money = ({ amount = 0, currency = 'AUD', decimalPlaces, explicit }) => {
  const numericAmount = Number(amount) || 0
  const formattingOptions = {
    ...symbolFormattingOnly,
    ...(decimalPlaces && {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
    }),
    currency
  }

  // locale being set to undefined shouldn't have much effect
  // as using narrowSymbol only shows the symbol for the currency
  const numberFormat = new Intl.NumberFormat(undefined, formattingOptions).format(numericAmount)

  if (explicit) {
    return `${numberFormat} ${currency}`
  }
  return numberFormat
}
